import React from 'react';

const Footer = () => {
  return (
    <footer style={{ background: 'var(--bg-card)', borderTop: '2px solid var(--border-medium)', padding: '60px 0 40px' }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '60px', marginBottom: '60px' }}>
          {/* Brand */}
          <div style={{ maxWidth: '300px' }}>
            <h3
              style={{
                fontSize: '1.5rem',
                fontWeight: '900',
                color: 'var(--brand-primary)',
                marginBottom: '16px',
                fontFamily: "'PP Right Grotesk', Arial, sans-serif",
                textTransform: 'uppercase',
              }}
            >
              Switch Schools
            </h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              The parent diagnostic platform for Malaysian international schools. Make informed decisions about your child's education.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="caption"
              style={{
                color: 'var(--text-primary)',
                marginBottom: '20px',
              }}
            >
              Quick Links
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['How It Works', 'Pricing', 'About Us', 'Contact'].map((link) => (
                <li key={link} style={{ marginBottom: '12px' }}>
                  <a
                    href="#"
                    className="link-text"
                    style={{
                      fontSize: '1rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease',
                    }}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4
              className="caption"
              style={{
                color: 'var(--text-primary)',
                marginBottom: '20px',
              }}
            >
              Legal
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Privacy Policy', 'Terms of Service', 'PDPA Compliance', 'Refund Policy'].map((link) => (
                <li key={link} style={{ marginBottom: '12px' }}>
                  <a
                    href="#"
                    className="link-text"
                    style={{
                      fontSize: '1rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease',
                    }}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div style={{ borderTop: '2px solid var(--border-medium)', paddingTop: '32px', textAlign: 'center' }}>
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            © 2024 Switch Schools. All rights reserved. Made with care for Malaysian parents.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
